module.exports = __webpack_public_path__ + "img/source03_b4.a2148b9a.png";